import React, { useState, useRef } from "react";

function Header() {
  const [isActive, setIsActive] = useState(false);
  const hiddenRef = useRef(null);

  function handleClick() {
    const hiddenElement = hiddenRef.current;
    setIsActive(!isActive);
    hiddenElement.classList.toggle("hidden");
  }

  return (
    <div className="fixed top-0 w-full z-50 ">
      <header className="navbar-fixed h-20 flex items-center justify-around bg-transparent">
        <div className="container">
          <div className="relative flex items-center justify-between">
            <div className="px-4">
              <a
                href="#home"
                className="block font-bold md:text-lg lg:text-2xl"
                style={{ WebkitTapHighlightColor: "transparent" }}
              >
                KHAIRUL <span className="text-primary">HADI</span>
              </a>
            </div>
            <div className="flex items-stretch h-full px-4">
              <button
                style={{ WebkitTapHighlightColor: "transparent" }}
                id="hamburger"
                className={`${
                  isActive ? "hamburger-active" : ""
                } absolute right-4 -top-2 block md:hidden`}
                onClick={handleClick}
              >
                <span className="my-2 block h-[2px] w-[30px] origin-top-left bg-black transition duration-300 ease-in-out"></span>
                <span className="my-2 block h-[2px] w-[30px] bg-black transition duration-300 ease-in-out"></span>
                <span className="my-2 block h-[2px] w-[30px] origin-bottom-left bg-black transition duration-300 ease-in-out"></span>
              </button>
              <nav
                ref={hiddenRef}
                className={`absolute right-0 top-full hidden w-full max-w-[250px] rounded-lg bg-white py-5 shadow-lg md:static md:block md:rounded-none md:bg-transparent md:py-0  md:shadow-none md:max-w-full`}
                onClick={handleClick}
              >
                <ul className="blok m-2 md:flex">
                  <li className="group p-2 md:pl-5">
                    <a
                      href="/#home"
                      className="text-base font-medium text-slate-600 group-hover:text-primary md:text-xl md:font-semibold"
                    >
                      Home
                    </a>
                  </li>
                  <li className="group p-2 md:pl-5">
                    <a
                      href="/#about"
                      className="text-base font-medium text-slate-600 group-hover:text-primary md:text-xl md:font-semibold"
                    >
                      About
                    </a>
                  </li>
                  <li className="group p-2 md:pl-5">
                    <a
                      href="/#blog"
                      className="text-base font-medium text-slate-600 group-hover:text-primary md:text-xl md:font-semibold"
                    >
                      Blog
                    </a>
                  </li>
                  <li className="group p-2 md:pl-5">
                    <a
                      href="/#quote"
                      className="text-base font-medium text-slate-600 group-hover:text-primary md:text-xl md:font-semibold"
                    >
                      Quote
                    </a>
                  </li>
                  <li className="group p-2 md:pl-5">
                    <a
                      href="project"
                      className="text-base font-medium text-slate-600 group-hover:text-primary md:text-xl md:font-semibold"
                      >
                        Project
                      </a>
                    </li>
                    <li className="group p-2 md:pl-5">
                      <a
                        href="/#contact"
                        className="text-base font-medium text-slate-600 group-hover:text-primary md:text-xl md:font-semibold"
                      >
                        Contact
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </header>
        </div>
      );
    }
    
    
    export default Header;
    
